module.exports = __webpack_public_path__ + "static/media/Imagen-no-disponible-282x300.a057007c.png";